<template>
  <v-navigation-drawer
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :expand-on-hover="!value"
    :permanent="!value"
    app
  >
    <v-list dense>
      <v-list-item link :to="{ name: 'home' }">
        <v-list-item-action>
          <v-icon>fas fa-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("global.menu.home") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <slot name="menu-content"></slot>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "RwNavigationDrawer",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>
